import { find } from 'lodash';
import PropTypes from 'prop-types';
import cx from 'classnames';
import React, { useState } from 'react';
import { components } from 'react-select';
import { Checkbox } from '@chaser/components';
import style from './ChaserMultiInvoiceSelect.module.scss';
import ChaserStyledSelect from '../ChaserStyledSelect';

const Option = props => {
  // eslint-disable-next-line react/prop-types
  const { isSelected, label, selectOption } = props;
  return (
    <div
      className={cx(style.option, isSelected && style.selected)}
      onClick={() => selectOption(props)}
    >
      <span className={style.checkboxWrapper} style={{ pointerEvents: 'none' }}>
        <Checkbox style={{ pointerEvents: 'none' }} checked={isSelected}>
          {label}
        </Checkbox>
      </span>
    </div>
  );
};
// eslint-disable-next-line react/prop-types
const MultiValue = ({ children, ...props }) => {
  // eslint-disable-next-line react/destructuring-assignment
  // eslint-disable-next-line react/prop-types
  const { getValue } = props;
  const value = getValue();
  if (children === 'Select all') {
    return null;
  }
  let total = value.length;
  if (value.length > 1) {
    const firstValue = value[0].label;
    if (firstValue === 'Select all') {
      total -= 1;
      if (children !== value[1].label) {
        return null;
      }
    } else if (children !== value[0].label) {
      return null;
    }
  }
  const label = total > 1 ? `${total} invoices` : children;
  return (
    <components.MultiValue components={components} {...props}>
      {label}
    </components.MultiValue>
  );
};

const ChaserMultiInvoiceSelect = ({ invoices = [], selected = [], onChange = () => {} }) => {
  const [selectedInvoices, setSelectedInvoices] = useState(
    selected.map(i => ({ label: i.InvoiceNumber, value: i._id })),
  );
  const options = [
    { value: 'all', label: 'Select all' },
    ...invoices.map(i => ({
      value: i._id,
      label: i.InvoiceNumber,
    })),
  ];

  const getSelectedInvoices = givenOptions =>
    givenOptions.reduce((result, option) => {
      const invoice = find(invoices, i => i._id === option.value);
      return invoice ? result.concat(invoice) : result;
    }, []);
  return (
    <div data-testid="invoice-select" onClick={e => e.stopPropagation()}>
      <ChaserStyledSelect
        options={options}
        isMulti
        placeholder="Select invoices"
        noOptionsMessage={() => 'No invoices found'}
        value={selectedInvoices}
        components={{ Option, MultiValue }}
        onChange={(_, { action, option }) => {
          if (action === 'select-option') {
            if (!option || !option.data) {
              return;
            }
            const newSelectedOptions = [...selectedInvoices, option];
            if (option.data.value === 'all' || newSelectedOptions.length === invoices.length) {
              setSelectedInvoices(options);
              onChange(getSelectedInvoices(options));
            } else {
              setSelectedInvoices(newSelectedOptions);
              onChange(getSelectedInvoices(newSelectedOptions));
            }
          } else if (action === 'deselect-option') {
            if (!option || !option.data) {
              return;
            }
            let newSelectedOptions = [];
            if (option.data.value !== 'all') {
              newSelectedOptions = selectedInvoices.filter(
                i => i.value !== option.data.value && i.value !== 'all',
              );
            }
            setSelectedInvoices(newSelectedOptions);
            onChange(getSelectedInvoices(newSelectedOptions));
          } else if (action === 'remove-value' || action === 'pop-value') {
            setSelectedInvoices([]);
            onChange([]);
          }
        }}
      />
    </div>
  );
};

ChaserMultiInvoiceSelect.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      InvoiceNumber: PropTypes.string.isRequired,
    }),
  ),
  selected: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      InvoiceNumber: PropTypes.string.isRequired,
    }),
  ),
  onChange: PropTypes.func,
};

export default ChaserMultiInvoiceSelect;
